var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 50,
    viewBox: "0 0 58 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.21875 28.125H50.9688V6.25H7.21875V28.125ZM8.78125 7.8125H49.4062V26.5625H8.78125V7.8125ZM52.5312 0H5.65625C3.06836 0 0.96875 2.09961 0.96875 4.6875V35.9375C0.96875 38.5254 3.06836 40.625 5.65625 40.625H23.3223L20.7178 48.4375H14.25C13.8203 48.4375 13.4688 48.7891 13.4688 49.2188C13.4688 49.6484 13.8203 50 14.25 50H43.9375C44.3678 50 44.7188 49.6506 44.7188 49.2188C44.7188 48.7869 44.3678 48.4375 43.9375 48.4375H37.4717L34.8672 40.625H52.5312C55.1191 40.625 57.2188 38.5254 57.2188 35.9375V4.6875C57.2188 2.09961 55.1191 0 52.5312 0ZM35.8223 48.4375H22.3652L24.9697 40.625H33.2178L35.8223 48.4375ZM55.6562 35.9375C55.6562 37.6602 54.2539 39.0625 52.5312 39.0625H5.65625C3.93359 39.0625 2.53125 37.6602 2.53125 35.9375V4.6875C2.53125 2.96484 3.93359 1.5625 5.65625 1.5625H52.5312C54.2539 1.5625 55.6562 2.96484 55.6562 4.6875V35.9375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.aee738be0ea075b6ec40a5321ae96593.svg";
export { ForwardRef as ReactComponent };